import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTotals } from '../helpers';
import TotalItem from './components/TotalItem';
import classes from './TotalSection.module.scss';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../utils/constants';

function VerticalDevider() {
  return (
    <div style={{ width: '0', height: '100%', border: '1.5px solid #F6F7F9' }} className={classes.onlyForDesktop} />
  );
}

export default function TotalSection({ data, workTypes, rateType }) {
  const { t } = useTranslation();
  const size = useWindowSize();

  const totals = getTotals(data);

  return (
    <section className={classes.container}>
      {size.width < responsiveSizeTimesheet && (
        <p className={classes.totalLabel}>{t('dashboard.timesheet.total.total_time')}</p>
      )}
      <TotalItem
        item={t('dashboard.timesheet.total.standard_time')}
        value={totals[workTypes?.find((x) => x.key === 1)?.label]}
        rateType={rateType}
      />
      <VerticalDevider className={classes.onlyForDesktop} />
      <TotalItem
        item={t('dashboard.timesheet.total.over_time')}
        value={totals[workTypes?.find((x) => x.key === 2)?.label]}
        rateType={rateType}
      />
      <VerticalDevider className={classes.onlyForDesktop} />
      {size.width > responsiveSizeTimesheet && (
        <TotalItem
          item={t('dashboard.timesheet.total.pto')}
          value={totals[workTypes?.find((x) => x.key === 5)?.label]}
          rateType={rateType}
        />
      )}
      <VerticalDevider className={classes.onlyForDesktop} />
      <TotalItem item={t('dashboard.timesheet.total.total_time')} value={totals['Total Time']} rateType={rateType} />
    </section>
  );
}
